var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAllTokens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07 13L7.57 11.34H5.24L4.74 13H3.2L5.5 6.02H7.38L9.65 13H8.07ZM6.42 7.4H6.37L5.6 10.05H7.2L6.42 7.4ZM12.0057 13C11.499 13 11.1257 12.8767 10.8857 12.63C10.6524 12.3833 10.5357 12.0267 10.5357 11.56V5.6H12.0157V11.85H12.6757V13H12.0057ZM14.9549 13C14.4483 13 14.0749 12.8767 13.8349 12.63C13.6016 12.3833 13.4849 12.0267 13.4849 11.56V5.6H14.9649V11.85H15.6249V13H14.9549Z",
    fill: "#010101"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllTokens);
export default __webpack_public_path__ + "static/media/allTokens.15ab1b5fead69e55046c496230d70203.svg";
export { ForwardRef as ReactComponent };